export const scaleMap = [
    10000000, 5000000, 2000000, 1000000, 500000, 200000, 100000, 50000, 30000,
    10000, 5000, 3000, 2000, 1000, 500, 300, 100, 50,
];
